import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import IcCopy from 'assets/Icons/copy';
import { set } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';

const ButtonViewFullStaff = () => {
  const [isFull, setIsFull] = useState(false);
  const [calendarDom, setCalendarDom] = useState<HTMLElement | null>(null);
  const [calendarHeaderDom, setCalendarHeaderDom] = useState<HTMLElement | null>(null);
  const cacheCalendar = (): (HTMLElement | null) => {
    // if (calendarDom) return calendarDom;
    const calendar = document.getElementById('calendar');
    // setCalendarDom(calendar || null);
    return calendar;
  };
  const cacheHeaderCalendar = (): (HTMLElement | null) => {
    // if (calendarHeaderDom) return calendarHeaderDom;
    const calendar = document.getElementById('calendar-header');
    // setCalendarDom(calendar || null);
    return calendar;
  };

  const onViewFull = () => {
    const calendar = cacheCalendar();
    const headerCalendar = cacheHeaderCalendar();
    if (!calendar || !headerCalendar) return;
    if (calendar?.className.includes('view-full-mode')) {
      calendar?.classList.remove('view-full-mode');
      set(calendar, 'style.zoom', '1');
      headerCalendar.classList.remove('calendar-header-hidden');
      setIsFull(false);
    } else {
      calendar?.classList.add('view-full-mode');
      headerCalendar.classList.add('calendar-header-hidden');
      set(calendar, 'style.zoom', '0.7');
      setIsFull(true);
    }
  };
  return (
    <Container type='button' onClick={onViewFull}>
      {isFull ? <FullscreenExitOutlined style={{ fontSize: '30px' }} /> : <FullscreenOutlined style={{ fontSize: '30px' }} />}
    </Container>
  );
};

export default ButtonViewFullStaff;
const Container = styled.button`
  position: absolute;
  z-index: 99;
  bottom: 16px;
  right: 16px;
  width: 80px;
  height: 80px;
  border-radius: 100px;
  background: #FFF;
  box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40), 0 4px 8px -3px rgba(45, 35, 66, 0.30), 0 -3px 0 0 #D6D6E7 inset;
  &:active {
    background: #eee;
  }
`;